import styled from 'styled-components';

const RowTitle = styled.div`
    font-size: 16px;
    line-height: 30px;
    padding-top: 9px;
    border-bottom: 1px solid rgb(224, 224, 224);
`;

export default RowTitle;



// WEBPACK FOOTER //
// ./src/components/list/Filters/layout/RowTitle.js